import classNames from 'classnames';

import { SectionTitle, TextBlock } from '@/ui/index';
import { Flash } from '@/icons/index';

import styles from './TextSection.module.scss';

const TextSection = ({ data, className }) => {
  return (
    <section
      className={classNames(styles['text-section'], className)}
      itemScope
      itemType='https://schema.org/Article'
    >
      <div className={styles['text-section__wrapper']}>
        {data?.title && (
          <SectionTitle
            className={classNames(styles['text-section__title'])}
            titleModify={'title--large'}
            Icon={Flash}
          >
            {data?.title}
          </SectionTitle>
        )}
        {data?.text && (
          <TextBlock
            className={classNames(
              styles['text-section__content'],
              'text--large',
            )}
            isHtml
          >
            {data.text}
          </TextBlock>
        )}
      </div>
    </section>
  );
};

export default TextSection;
